module.exports = __webpack_public_path__ + "media/images/wallet_icon_inactive-3492e384.svg";